import ClientDto from './client-dto';
import User from '@vertical-plus/vue-js-micro-service-components/lib/model/entity/organisation/user';

export default class ClientUserDto
{
    public id: number|null = null;
    public client: ClientDto|null = null;
    public accountManager: User|null = null;
    public title = '';
    public firstName = '';
    public lastName = '';
    public email = '';
    public username = '';
    public password = '';
    public disabled = false;
}